import React from "react";
import { ExtraProps } from "../../../schemed/FormControlProps";
import { usePowerEditorSettings } from "../../PowerEditorSettingsContext";
import { PowerEditorBase } from "../../slate/PowerEditorBase";
import { Schema } from "../../../../hooks/useSchema";
import { FormControl } from "../../../schemed";
import { PreconfiguredField } from "../CustomFieldsBlock/usePreconfiguredFields";

interface PreconfiguredEditorProps {
  schema: Schema;
  field: PreconfiguredField;
  row: any;
  updateRow: (id: string, changes: any) => void;
  autoFocus?: boolean;
}


const DefaultPreconfigureExtraProps: ExtraProps = { autoComplete: true, label: " " };
const DefaultPreconfigureExtraPropsWithAF: ExtraProps = { ...DefaultPreconfigureExtraProps, controlProps: { autoFocus: true } };

export const PreconfiguredEditor = (props: PreconfiguredEditorProps) => {
  const { field: f, schema, row, updateRow } = props;
  const settings = usePowerEditorSettings();
  const EditorComponent = settings.EditorComponent || PowerEditorBase;

  if(f.type === "powerdoc") {
    return (
      <EditorComponent
        key={f.code}
        content={row[f.code]}
        update={v => updateRow(row._id, { [f.code]: v })}
        />)
  }
  return (
    <FormControl
      field={f.code}
      row={row}
      extraProps={props.autoFocus ? DefaultPreconfigureExtraPropsWithAF : DefaultPreconfigureExtraProps}
      schema={schema[f.code]}
      onChange={(o,c) => updateRow(row._id, c)}
      />
  );
}
